import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isDate/index.js';

var require$$3 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$3 as default };
